import React from "react";
import { Link } from "react-router-dom";
import { Home, Snowflake } from "lucide-react";
import { cn } from "../lib/utils";

export default function Logo({ className, size = "md" }) {
  const sizes = {
    sm: { box: "h-9 w-9", icon: 18, flake: 11, text: "text-base", sub: "text-[10px]" },
    md: { box: "h-11 w-11", icon: 22, flake: 13, text: "text-lg", sub: "text-[11px]" },
    lg: { box: "h-14 w-14", icon: 28, flake: 16, text: "text-2xl", sub: "text-xs" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <Link to="/" className={cn("logo-link flex items-center gap-3 group", className)} data-testid="logo-link" aria-label="HOUSTO A/C - Home">
      <div className={cn("relative rounded-xl bg-primary text-primary-foreground grid place-items-center shadow-md shadow-primary/20", s.box)}>
        <Home size={s.icon} strokeWidth={2.25} aria-hidden="true" />
        <Snowflake
          className="logo-flake absolute"
          size={s.flake}
          strokeWidth={2.5}
          aria-hidden="true"
          style={{ marginTop: "3px" }}
        />
      </div>
      <div className="leading-none">
        <div className={cn("font-display font-extrabold tracking-tight text-foreground", s.text)}>HOUSTO</div>
        <div className={cn("font-light tracking-[0.25em] text-muted-foreground mt-1", s.sub)}>A/C</div>
      </div>
    </Link>
  );
}
